export const CLOCK = "clock";
export const CUSTOM = "custom";



